import { createStore } from "vuex";
import { RootState, state } from "@/store/state";
import getters from "@/store/getters";
import { actions } from "@/store/actions";
import { mutations } from "@/store/mutations";
import { ICase } from "@/models/case";
import { ISlide } from "@/models/slide";
import { Heatmap, IHeatmapConfig } from "@/models/heatmap";
import loginModule from "@/modules/login/store";
import statisticsModule from "@/modules/statistics/store";
import { WorkflowState } from "@/models/workflow-state";
import reportsModule from "@/store/reports";
import { BFF_BASE_PATH } from "@/core/utils";

export default createStore({
  state,
  getters,
  // TODO: Move all mutations to mutations.ts, use actions from components and mutations only from actions
  mutations: {
    setHeatmapLoader(state: RootState, isLoading: boolean) {
      state.isLoadingHeatmap = isLoading;
    },
    globals(state: RootState, data: any) {
      state.globals = data;
    },
    case(state: RootState, updatedCase: ICase) {
      state.cases = state.cases.map((caseObj) => {
        if (caseObj.caseId === updatedCase.caseId) {
          return updatedCase;
        } else {
          return caseObj;
        }
      });
    },
    slides(state: RootState, data: ISlide[]) {
      state.slides = data;
    },
    removeCurrentSlide(state: RootState) {
      state.currentSlide = {
        id: "",
        name: "",
        dimensions: [0, 0],
        minimapDimensions: [0, 0],
        stain: "",
        tissueType: "",
        heatmaps: [],
        POIs: [],
      };
      state.activeHeatmaps = [];
      state.activeSlideId = "";
    },
    updateHeatmapsOpacity(state: RootState, opacity: number) {
      state.heatmapsOpacity = opacity;
    },
    clearAllHeatmaps(state: RootState) {
      state.activeHeatmaps = [];
    },
    toggleHeatmap(state: RootState, heatmap: IHeatmapConfig) {
      let isTransitioning = false;
      if (!state.isVisible) {
        isTransitioning = true;
        state.isVisible = true;
      }
      if (
        state.activeHeatmaps.some((hm: Heatmap) => hm.classification === heatmap.classification)
      ) {
        state.activeHeatmaps = state.activeHeatmaps.map((hm: Heatmap) => {
          if (hm.classification === heatmap.classification) {
            hm.isActive = !hm.isActive;
            if (isTransitioning) {
              hm.isActive = true;
            }
            if (hm.isActive) {
              state.heatmapsOpacity = heatmap.opacity;
            }
          } else {
            hm.isActive = false;
          }
          return hm;
        });
      } else {
        state.activeHeatmaps.map((hm: Heatmap) => {
          hm.isActive = false;
        });

        const slideName = state.currentSlide.id;
        const classification = heatmap.classification;
        const path = `${BFF_BASE_PATH}/get_heatmap/${btoa(slideName)}/${classification}`;
        const style = `width:${state.currentSlide.dimensions[0]}px; height: ${state.currentSlide.dimensions[1]}px; background-image: url("${path}"); background-size: ${state.currentSlide.dimensions[0]}px ${state.currentSlide.dimensions[1]}px`;
        const isActive = true;

        state.activeHeatmaps = [
          ...state.activeHeatmaps,
          new Heatmap(slideName, classification, path, style, isActive, heatmap),
        ];

        state.heatmapsOpacity = heatmap.opacity;
        state.isLoadingHeatmap = false;
      }
      state.isQuantificationLegend = heatmap.isQuantificationLegend;
    },
    toggleActiveHeatmaps(state: RootState) {
      if (state.isVisible) {
        state.isVisible = false;
      } else {
        state.isVisible = true;
      }
    },
    hideActiveHeatmaps(state: RootState) {
      if (state.isVisible) {
        state.isVisible = false;
      }
    },
    ...mutations,
  },
  actions,
  modules: {
    loginModule,
    statisticsModule,
    reportsModule,
  },
});
